import React, { Component } from "react";

class Spinner extends Component {
  render() {
    return (
      <div className="row mx-0">
        <div className="col-12 text-center py-3">
          <span className="spinner-border color-second"></span>
        </div>
      </div>
    );
  }
}

export default Spinner;
